// extracted by mini-css-extract-plugin
export default {"highlight":"TextWithHighlight__highlight-m5Yn"};